import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { tap } from 'rxjs/operators';
import { BrowserStorageService } from '../common/browser-storage.service';
import { ApiCallsService } from './api-calls.service';
import { NetworkService } from './network.service';

@Injectable({
  providedIn: 'root',
})
export class TokenInterceptorService implements HttpInterceptor {
  constructor(
    private _apiService: ApiCallsService,
    private _storageService: BrowserStorageService,
    private _networkService: NetworkService,
  ) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (this._storageService.getBrowser() && !this._networkService.isOnline()) {
      this._apiService?.errorAlert('No Internet Connection', false, '', {});
      return throwError(() => new Error('No Internet Connection'));
    }
    const token = this._storageService.getCookie('authToken') ? this._storageService.getCookie('authToken') : '';
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const language = this._storageService.getLanguage(); // Fallback to 'en-US' if no language is found
    // Clone the request to include headers
    let clonedRequest = req.clone({
      setHeaders: {
        'Time-Zone': timezone,
        'Accept-Language': language,
      },
    });

    if (token) {
      clonedRequest = clonedRequest.clone({
        setHeaders: { Authorization: `Bearer ${token}` },
      });
    }

    if (this._apiService.showLoader) {
      this._apiService.loader(true);
    } else {
      this._apiService.showLoader = true;
    }

    // Handle the request and response
    return next.handle(clonedRequest).pipe(
      tap(
        (event: HttpEvent<any>) => {
          if (event instanceof HttpResponse) {
            this._apiService.loader(false);
          }
        },
        (error: any) => {
          this._apiService.loader(false);
          if (error instanceof HttpErrorResponse) {
            if (error) {
              if (error?.status === 401 || error?.status === 520) {
                this._apiService?.errorAlert(error?.error?.message, true, '', error);
              } else {
                this._apiService?.errorAlert(error?.error?.message, false, '', error);
              }
            }
          }
        },
      ),
    );
  }
}
